import { reactive, watch, SetupContext } from '@vue/composition-api';

export const useAdvisorSearchForm = (
  props: { value: string },
  { root }: Pick<SetupContext, 'root'>,
) => {
  const state = reactive({
    searchText: props.value,
  });

  watch(
    () => props.value,
    () => {
      state.searchText = props.value;
    },
  );

  const onInput = (value: string) => {
    state.searchText = value;
  };
  const search = () => {
    root.$router
      .push({
        query: { keyword: state.searchText.trim() },
      })
      .catch(() => {});
  };

  return {
    state,
    onInput,
    search,
  };
};
